import React from "react";

export interface Props {
  text: string;
}
const HeadingLabel = ({ text }: Props) => {
  return (
    <label
      style={{
        color: "#08749B",
        fontWeight: 500,
        display: "contents",
        marginRight: 1,
      }}
    >
      {text}
    </label>
  );
};

export default HeadingLabel;
